const zh_TW = {
    // homepage
    homepage_title: '日曆清單手機版下載',
    homepage_slogn: '日曆清單手機版本',
    homepage_ios_download: 'AppStore審核中...',
    homepage_download: '立即下載',


    // 手机下载
    phonedownload_title: '掃二維碼下載日曆清單手機版',
    phonedownload_slogan: '手機版日曆清單可以和電腦版日曆清單實時同步隨時隨地記錄瑣事',
    phonedownload_send_vip: '安裝日曆清單App，送VIP會員',
    phonedownload_screenshot: '屏幕快照',
    phodedownload_macos: '日曆清單macOS電腦版本',
    phodedownload_windows: '日曆清單windows電腦版本',
    phodedownload_otherbutton: "立即查看",
    phodedownload_about: '聯繫我們',
    phodedownload_copyright: ' ',

    //特点
    feature_no_ad: '無廣告',
    feature_easy: '月視圖、簡潔易用',
    feature_reminder: '自定義提醒',
    feature_countdown: '倒數紀念日',

    vip_task_succ:' 領取成功，請下載手機版啟動VIP',
    vip_task_error:' 領取失敗',

    
    //课程表
    tt_title: '日曆清單',
    tt_share_1: '向您分享了',
    tt_share_2: '課程表',
    tt_share_show_1: '您用「日曆清單」APP掃二維碼，電腦端和手機端會自動顯示出',
    tt_share_show_2: '的課程表',
    tt_share_scan_1: '用',
    tt_share_scan_2: '「日曆清單」APP掃碼',
    tt_share_succ: '同步成功',
    
    // V2版权信息
    v2_copyright: '聯繫我們 service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. All rights reserved.',
    v2_download_appstore: 'Download on the App Store',
    v2_download_googleplay: 'GET IT ON Google Play',
    
    // V2中间部分内容
    v2_main_title: '日曆清單 手機端',
    v2_main_title_part1: '日曆清單',
    v2_main_title_part2: '手機端',
    v2_main_description: '您可以在App Store或Google Play搜尋<span class="name">CalendarTask</span>下載。',
    v2_download_ios: '下載 iOS',
    v2_download_android: '下載 Android',
    v2_download_harmonyos: '下載 HarmonyOS',
    v2_sync_status: '同步完成!上傳1條記錄,下載0條記錄',
    v2_feature_title: '多端數據同步',
    v2_feature_description: '可在手機、平板、電腦等,多設備之間即時同步數據'

}


export default zh_TW;